import {AI} from 'Constants/ActionTypes';

const {
  GET_WORD_STRATEGY_ID_OPTIONS,
  SET_QUESTION_STUDY_SEARCH_DATA,
  SET_QUESTION_STUDY_TAB_ACTIVE_KEY,
  GET_QUESTION_STUDY_LIST,
  SET_QUESTION_STUDY_PAGE_STATUS,
  GET_QUESTION_STUDY_DETAIL_DRAWER_DATA,
} = AI;

const initialState = {
  wordStrategyIdOptions: [], // 话术名称下拉框
  searchData: {
    wordStrategyId: 0,
    status: 1,
  }, // 搜索条件
  tabActiveKey: '1', // tab的activeKey
  tableListData: {
    data: [],
    total: 0,
  }, // table数据
  pageStatus: {
    pageNum: 1,
    pageSize: 20,
  }, // pageNum与pageSize
  detailDrawerData: {}, // 通话详情抽屉数据
};

const questionStudy = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_WORD_STRATEGY_ID_OPTIONS}_SUCCESS`:
      return {
        ...state,
        wordStrategyIdOptions: action.payload.data,
      };
    case `${SET_QUESTION_STUDY_SEARCH_DATA}`:
      return {
        ...state,
        searchData: {...state.searchData, ...action.data},
      };
    case `${SET_QUESTION_STUDY_TAB_ACTIVE_KEY}`:
      return {
        ...state,
        tabActiveKey: action.data,
      };
    case `${GET_QUESTION_STUDY_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.list) || [],
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    case `${GET_QUESTION_STUDY_LIST}_FAIL`:
      return {
        ...state,
        tableListData: {
          data: [],
          total: 0,
        },
      };
    case `${SET_QUESTION_STUDY_PAGE_STATUS}`:
      return {
        ...state,
        pageStatus: {...state.pageStatus, ...action.data},
      };
    case `${GET_QUESTION_STUDY_DETAIL_DRAWER_DATA}_SUCCESS`:
      return {
        ...state,
        detailDrawerData: action.payload.data || {},
      };
    case `${GET_QUESTION_STUDY_DETAIL_DRAWER_DATA}_FAIL`:
      return {
        ...state,
        detailDrawerData: {},
      };
    default:
      return state;
  }
};

export default questionStudy;
